import React from 'react';
import { Avatar, Image, Space } from 'antd';

// ProfileAvatar Component to display either an avatar with initials or the profile picture
const ProfileAvatar = ({ profilePicture, name, size = '30px' }) => {
    return (
        <Space>
            {profilePicture ? (
                <Image
                    src={profilePicture}
                    height={size}
                    preview={false}
                    width={size}
                    style={{
                        borderRadius: '50%',
                        objectFit: "cover"
                    }}
                />
            ) : (
                <Avatar
                    style={{
                        backgroundColor: 'rgb(0 10 129 / 25%)',
                        cursor: 'pointer',
                    }}
                >
                    {name[0].toUpperCase()}
                    {/* {name.split(' ')[1] && name.split(' ')[1][0].toUpperCase()} */}
                </Avatar>
            )}
        </Space>
    );
};

export default ProfileAvatar;
